export default {
    buttons: {
        back: "Dos",
        next: "Suivant",
        submit: "Soumettre"
    }
}